import store from '@/store'

export default {
    computed: {
        loadings () {
            return store.getters['loading/loadings']
                .filter(loading => loading.originId === this._uid)
        },

        loadingKeys () {
            return this.loadings.map(loading => loading.key)
        },

        isIdtLoading () {
            return !!this.loadings.length
        },

        loadingsOverall () {
            return store.getters['loading/loadings']
        },

        loadingKeysOverall () {
            return this.loadingsOverall.map(loading => loading.key)
        },

        isLoadingOverall () {
            return !!this.loadingsOverall.length
        }
    },

    methods: {
        loadingAdd (key) {
            store.dispatch('loading/loadingAdd', {
                originId: this._uid,
                key
            })
        },

        loadingRemove (key) {
            store.dispatch('loading/loadingRemove', {
                originId: this._uid,
                key
            })
        }
    }
}
